import React from "react";

import { Input } from "@/components/ui/input";

interface ChangeSummaryFieldProps {
  message: string;
  setMessage: (message: string) => void;
  label?: string;
  placeholder?: string;
}

export const ChangeSummaryField = ({
  message,
  setMessage,
  label = "Version change summary (Optional)",
  placeholder = "Enter a change summary",
}: ChangeSummaryFieldProps) => (
  <div className="flex flex-col gap-y-2">
    <span className="text-xs text-gray-500">{label}</span>
    <Input placeholder={placeholder} value={message} onChange={e => setMessage(e.target.value)} />
  </div>
);
